export const DEFAULT_INPUT = {
  project_name: "",
  technician: "",
  site_address: "",

  iron_ppm: "",
  manganese_ppm: "",
  h2s_ppm: "",
  h2s_mode: "odor",
  ammonia_ppm: "",
  tannins_ppm: "",
  arsenic_ppm: "",
  nitrites_ppm: "",
  toc_enabled: false,        // NEW: TOC checkbox; unchecked by default
  toc_ppm: "",
  turbidity_ntu: "",
  iron_bacteria_present: false,
  coliform_present: false,

  ph: 7.5,
  temp_f: 55,

  flow_rate_gpm: 10,
  pipe_size_in: 1.0,

  retention_tank_type: "RT40",
  retention_tank_custom_gallons: "",
  allow_rt40_dose_boost: true,

  daily_usage_gallons: 300,

  // 6 ppm default — includes safety margin for downstream filtration
  target_residual_ppm: 6.0,
  stock_chlorine_pct: 12.5,
  refill_days: 14,

  soda_ash_enabled: false,
  target_ph: 8.0,
};

const NUMERIC_KEYS = new Set([
  "iron_ppm", "manganese_ppm", "h2s_ppm",
  "ammonia_ppm", "tannins_ppm", "arsenic_ppm",
  "nitrites_ppm", "toc_ppm", "turbidity_ntu",
  "ph", "temp_f",
  "flow_rate_gpm", "pipe_size_in",
  "retention_tank_custom_gallons",
  "daily_usage_gallons",
  "target_residual_ppm", "stock_chlorine_pct", "refill_days",
  "target_ph",
]);
const STRING_KEYS = new Set([
  "project_name", "technician", "site_address",
  "h2s_mode", "retention_tank_type",
]);
const BOOLEAN_KEYS = new Set([
  "iron_bacteria_present", "coliform_present",
  "allow_rt40_dose_boost", "soda_ash_enabled",
  "toc_enabled",
]);

export function normalizeInput(state) {
  const out = {};
  for (const [k, v] of Object.entries(state)) {
    if (NUMERIC_KEYS.has(k)) {
      if (v === "" || v === null || v === undefined) out[k] = 0;
      else { const n = Number(v); out[k] = Number.isFinite(n) ? n : 0; }
    } else if (BOOLEAN_KEYS.has(k)) {
      out[k] = Boolean(v);
    } else if (STRING_KEYS.has(k)) {
      out[k] = v == null ? "" : String(v);
    } else { out[k] = v; }
  }
  return out;
}

export const CONTAMINANTS = [
  { key: "iron_ppm", label: "Ferrous Iron (Fe²⁺)", unit: "ppm" },
  { key: "manganese_ppm", label: "Manganese (Mn²⁺)", unit: "ppm" },
  { key: "h2s_ppm", label: "Hydrogen Sulfide (H₂S)", unit: "ppm" },
  { key: "ammonia_ppm", label: "Ammonia (NH₃)", unit: "ppm" },
  { key: "tannins_ppm", label: "Tannins / Humic Acids", unit: "ppm" },
  { key: "arsenic_ppm", label: "Arsenic (As³⁺)", unit: "ppm" },
  { key: "nitrites_ppm", label: "Nitrites (NO₂⁻)", unit: "ppm" },
  { key: "turbidity_ntu", label: "Turbidity", unit: "NTU" },
];

export const PIPE_SIZES = [0.75, 1.0, 1.5, 2.0];
export const STOCK_PCTS = [6, 8.25, 10, 12.5];

export const RETENTION_TANK_OPTIONS = [
  { value: "none", label: "No Contact Tank", gallons: 0, desc: "Dose auto-boosted to compensate. If needed, recommend RT40 or RT80." },
  { value: "RT40", label: "RT40", gallons: 40, desc: "Standard residential contact tank — recommended for most installs." },
  { value: "RT80", label: "RT80", gallons: 80, desc: "Doubled volume — high-iron / manganese / slow-reaction sites." },
  { value: "custom", label: "Holding Tank", gallons: null, desc: "Customer already has a holding tank. Enter the gallons below." },
];

export const POSEIDON = {
  brand: "Poseidon Water Products",
  website: "www.poseidonwaterproducts.com",
  websiteUrl: "https://www.poseidonwaterproducts.com",
  appName: "ProDose",
  logo: "/poseidon-logo.png",
};
